import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Zap, FlaskConical, BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

type Tab = {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  end?: boolean;
};

const TABS: Tab[] = [
  { to: '/', label: 'Home', icon: LayoutDashboard, end: true },
  { to: '/quick-tests', label: 'Quick', icon: Zap },
  { to: '/tests', label: 'Tests', icon: FlaskConical },
  { to: '/reports', label: 'Reports', icon: BarChart3 },
];

export function MobileBottomNav() {
  const isMobile = useIsMobile();
  if (!isMobile) return null;

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="grid h-16 grid-cols-4">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-1 text-xs transition-colors',
                isActive
                  ? 'text-accent-blue'
                  : 'text-muted-foreground hover:text-foreground'
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span className="font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
